/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $GraphicsBox} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store, Signal} from '@gongxigames/framework/core';
import {slotStore} from '@gongxigames/framework/slotV2/globals';

type Props = {
    show: Signal<boolean>
};

export const $DebugGameFrame: FC<Props> = (props) => {
    const safeZoneGame = slotStore.stage_safeZoneState_game;
    const szGameFrameX = Store.computed(() => safeZoneGame.value.options.frame.x)    //         stage_safeZoneState_game.options.frame.x,
    const szGameFrameY = Store.computed(() => safeZoneGame.value.options.frame.y)    //         stage_safeZoneState_game.options.frame.y,
    const szGameFrameWidth = Store.computed(() => safeZoneGame.value.options.frame.width)    //         stage_safeZoneState_game.options.frame.width,
    const szGameFrameHeight = Store.computed(() => safeZoneGame.value.options.frame.height)    //         stage_safeZoneState_game.options.frame.height

    return <$GraphicsBox
        layer='TOP'
        name='DebugGameFrame'
        boxX={szGameFrameX}
        boxY={szGameFrameY}
        boxWidth={szGameFrameWidth}
        boxHeight={szGameFrameHeight}
        boxColor={0xFFFF00}
        boxAlpha={0.1}
        boxOutlineColor={0xFFFF00}
        boxOutlineAlignment={0}
        boxOutlineWidth={1}
        boxOutlineAlpha={1}
        visible={props.show}
    />;
};
